export interface FormInfo {
    knd?: string;
    formVersion?: string;
    periodDescription?: string;
    okud?: string;
    relevance?: boolean;
    dateRelease?: string;
    notice?: string;
    periodBeginNew?: string;
    relevanceMessage?: string;
    reportingDeadlines?: string;
}
